export default __webpack_public_path__ + "img/7a0d91b8788e6a07d1ac218b99a3b824.svg";